import { render, staticRenderFns } from "./Authz.vue?vue&type=template&id=2948c37d&"
import script from "./Authz.vue?vue&type=script&lang=js&"
export * from "./Authz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports